import React from 'react';

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import CraneBlack from 'src/images/crane_black.svg';

export const unavailableMessage = 'Origami is currently unavailable. Please try again later.';

export const SiteUnavailable = () => (
    <Row alignmentHorizontal="center" width="100%" height="100vh">
        <Column alignmentVertical="center" alignmentHorizontal="center" height="100%">
            <Text type="h600">{unavailableMessage}</Text>
            <img src={CraneBlack} alt="Logo" width={100} />
        </Column>
    </Row>
);
